export default "/images/rotate-ccw.svg?4888cf3bdf1664560318c6caf43d01ba";